import styles from "../../Styles/calendarDashboard.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";

const STATUS_ITEMS = [
  { labelKey: "taskStatusNotStarted" as const, swatchClass: styles.legendSwatchGray },
  { labelKey: "taskStatusInProgress" as const, swatchClass: styles.legendSwatchOrange },
  { labelKey: "taskStatusDone" as const, swatchClass: styles.legendSwatchGreen },
];

const PRIORITY_ITEMS = [
  { labelKey: "taskPriorityHigh" as const, dotClass: styles.priorityHigh },
  { labelKey: "taskPriorityMedium" as const, dotClass: styles.priorityMedium },
  { labelKey: "taskPriorityLow" as const, dotClass: styles.priorityLow },
];

export default function CalendarLegend() {
  return (
    <div className={styles.legend}>
      <span className={styles.legendGroupLabel}>{Vocabulary.calendarLegendStatus}:</span>
      {STATUS_ITEMS.map(({ labelKey, swatchClass }) => (
        <span key={labelKey} className={styles.legendItem}>
          <span className={`${styles.legendSwatch} ${swatchClass}`} />
          <span className={styles.legendItemLabel}>{Vocabulary[labelKey]}</span>
        </span>
      ))}

      <span className={styles.legendDivider} />

      <span className={styles.legendGroupLabel}>{Vocabulary.calendarLegendPriority}:</span>
      {PRIORITY_ITEMS.map(({ labelKey, dotClass }) => (
        <span key={labelKey} className={styles.legendItem}>
          <span className={`${styles.priorityDot} ${dotClass}`} />
          <span className={styles.legendItemLabel}>{Vocabulary[labelKey]}</span>
        </span>
      ))}
    </div>
  );
}
